import { Pipe, PipeTransform } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/naming-convention
import _uniq from 'lodash/uniq';
import { Message, MessageAuthor } from '../interface';

@Pipe({
  name: 'lastNUniqAuthors',
  standalone: true,
})
export class LastNUniqAuthorsPipe implements PipeTransform {
  transform(messages: Message[], count: number): MessageAuthor[] {
    return _uniq(messages.map(({ author }) => author)).slice(-count);
  }
}
